export const CloudIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 128 128"
    >
        <path
            fill="#E4EAEE"
            d="M23.45 62.3c.72-.72-1.27-9.29 7.6-15.91s14.92-2.67 15.77-2.96c.84-.28 4.79-17.6 21.4-22.1s33.93 3.94 38.01 18.02c3.73 12.87.84 21.54 1.27 22.1.42.56 8.45.28 13.09 7.74s2.96 12.11 2.96 12.11l-29.56 9.15h-47.3S5.02 79.47 4.6 77.5c-.42-1.97.53-8.37 7.32-12.25 5.9-3.37 10.26-1.68 11.53-2.95z"
        />
        <path
            fill="#BACDD2"
            d="M35.16 92.84s-15.78 3.3-26.45-4.96C2.29 82.9 4.63 74.83 4.63 74.83s4.6 4.65 13.89 5.91c9.29 1.27 19.71.84 19.71.84s2.6 4.44 12.39 6.48c12.27 2.55 18.74-3.73 18.74-3.73s3.36 4.02 15.19 4.3c11.83.28 18.46-7.98 19.57-8.17.56-.09 3.82 2.87 10.28 1.83 6.15-.99 9.39-3.66 9.39-3.66s.89 6.62-5.3 10.7c-4.83 3.18-13.23 3.52-13.23 3.52s-1.28 4.91-7.05 8.48c-5.36 3.33-14.6 4.44-21.44 2.4-8.59-2.56-10.72-6.47-10.72-6.47s-6.4 3.75-16.4 2.48c-9.45-1.18-14.49-6.9-14.49-6.9z"
        />
    </svg>
);

export const CloudLightningIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 128 128"
    >
        <path
            fill="#FECA18"
            d="M79.83 71.24 57 75.21s-7.6 19.36-8.07 20.67c-.47 1.31-.45 3.38 1.62 3.38 2.63 0 15.98-.07 15.98-.07s-3.24 15.63-3.43 17.03 1.31 2.63 2.63 1.22c1.31-1.41 19.51-24.79 20.3-25.93 1.41-2.04.05-3.92-1.55-4.01-1.6-.09-12.32.14-12.32.14l7.67-16.4z"
        />
        <path
            fill="#FDB900"
            d="M73.71 75.04s-5.09 11.26-5.28 11.9c-.56 1.9 1.9 2.67 2.6 1.13.7-1.55 6.76-14.08 6.76-14.08l-4.08 1.05zM50.83 96.3c1.34-.04 13.1-.07 14.08-.14 1.83-.14 2.11 2.39 0 2.39-2.19 0-13.73.04-14.43.07-1.62.08-1.83-2.25.35-2.32z"
        />
        <path
            fill="#FFE36A"
            d="M59.98 75.96s-6 15.06-6.34 16.19c-1.41 4.72 3.66 4.58 5 1.9.66-1.33 7.11-14.99 7.39-17.46.29-2.46-6.05-.63-6.05-.63zm2.54 15.2c-.86-.59-1.9-.07-2.53.92-.63.99-1.55 2.6-.14 3.45 1.27.76 2.39-.77 2.89-1.48.48-.7 1.11-1.97-.22-2.89zm9.57 3.24c-2.29-.49-3.03 1.41-3.52 3.66-.49 2.25-2.33 9.53-2.67 11.33-.49 2.53 1.83 2.89 2.82.56.74-1.74 3.95-9.59 4.36-10.84.63-1.89 1.33-4.22-.99-4.71z"
        />
        <path
            fill="#E4EAEE"
            d="M107.35 50.2s1.29-34.78-27.45-39C53.01 7.26 48.23 32.6 48.23 32.6s-11.68-2.67-18.02 4.79-6.48 13.23-6.48 13.23-17.6-1.69-19.15 12.67 11.54 8.45 11.54 8.45l107.13-4.72s2.95-8.03-4.65-13.73c-4.49-3.37-11.25-3.09-11.25-3.09z"
        />
        <radialGradient
            id="a"
            cx="65.43"
            cy="79.05"
            r="29.29"
            fx="52.31"
            fy="79.18"
            gradientTransform="matrix(.0288 -.9996 1.4975 .0432 -54.84 141.04)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".19" stopColor="#FFE366" />
            <stop offset=".33" stopColor="#EDDD82" />
            <stop offset=".57" stopColor="#D0D4AD" />
            <stop offset=".76" stopColor="#BFCFC7" />
            <stop offset=".87" stopColor="#B8CDD1" />
        </radialGradient>
        <path
            fill="url(#a)"
            d="M58.78 55.69c.84-.28 6.05 4.22 19.85 3.8s26.61-7.32 26.61-7.32-.7 4.93-2.25 7.32-4.22 5.21-4.22 5.21 7.18 1.69 13.66.84c6.48-.84 11.26-3.94 11.26-3.94s.84 3.24.28 6.34c-.72 3.97-4.22 6.9-7.18 7.32s-29.56 1.76-39.98 2.11c-8.45.29-56.63.68-61.52.14-5.07-.56-8.87-2.82-10.28-7.18-1.07-3.31-.56-5.35-.56-5.35s6.36 2.73 11.54 1.83c6.48-1.13 10-6.19 10-6.19s6.34 3.24 15.49 2.11c9.14-1.13 17.3-7.04 17.3-7.04z"
        />
    </svg>
);

export const FogIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 128 128"
    >
        <path
            fill="#CFD9DB"
            d="M116.62 124.26H11.32a7.52 7.52 0 0 1-7.52-7.52V11.44a7.52 7.52 0 0 1 7.52-7.52h105.3a7.52 7.52 0 0 1 7.52 7.52v105.3a7.51 7.51 0 0 1-7.52 7.52z"
        />
            <radialGradient
            id="a"
            cx="100.3"
            cy="-12.51"
            r="39.73"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".41" stopColor="#E7EBEB" />
            <stop offset=".61" stopColor="#E3E9E9" />
            <stop offset=".81" stopColor="#D7E1E4" />
            <stop offset=".98" stopColor="#C8D8DD" />
        </radialGradient>
        <path
            fill="url(#a)"
            d="M69.27 17.28s4.67-6.34 7.54-9.22 4.87-4.15 4.87-4.15h34.93a7.52 7.52 0 0 1 7.52 7.52v24.32L69.27 17.28z"
        />
        <radialGradient
            id="b"
            cx="48.27"
            cy="-9.32"
            r="63.7"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".41" stopColor="#E7EBEB" />
            <stop offset=".61" stopColor="#E3E9E9" />
            <stop offset=".81" stopColor="#D7E1E4" />
            <stop offset=".98" stopColor="#C8D8DD" />
        </radialGradient>
        <path
            fill="url(#b)"
            d="M40.03 3.91h-28.7a7.52 7.52 0 0 0-7.52 7.52v59.81s69.54 8.1 83.28 6.07l3.21-58.73s-6.87-7.78-22.63-8.07c-7.2-.13-16.53 2.8-17.65 2.08-1.29-.82-3.92-6.84-9.99-8.68z"
        />
        <radialGradient
            id="c"
            cx="93.33"
            cy="-65.53"
            r="135.29"
            fx="82.03"
            fy="-62.97"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".78" stopColor="#F4F4F5" />
            <stop offset=".83" stopColor="#EEF1F2" />
            <stop offset=".9" stopColor="#DDE7EA" />
            <stop offset=".98" stopColor="#C1D8DC" />
            <stop offset=".98" stopColor="#C0D8DC" />
        </radialGradient>
        <path
            fill="url(#c)"
            d="M47.63 102.24 22.37 53.67s2.06-17.44 19.64-25.26C57.56 21.5 69 26.68 69 26.68s11.66-14.94 31.52-13.82c19 1.08 23.63 9.28 23.63 9.28v94.59c0 4.16-76.52-14.49-76.52-14.49z"
        />
        <radialGradient
            id="d"
            cx="12.54"
            cy="22.39"
            r="108.71"
            gradientTransform="matrix(.2531 .9674 -1.5506 .4056 44.08 1.18)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".47" stopColor="#F1F1F0" />
            <stop offset=".58" stopColor="#ECEEEE" />
            <stop offset=".7" stopColor="#DEE7E8" />
            <stop offset=".84" stopColor="#C6DBDF" />
            <stop offset=".87" stopColor="#C0D8DC" />
        </radialGradient>
        <path
            fill="url(#d)"
            d="M124.15 77.69v39.05a7.52 7.52 0 0 1-7.52 7.52H11.32a7.52 7.52 0 0 1-7.52-7.52V40.79s5.32.46 12.94 4.58c7.58 4.09 12.05 10.07 12.05 10.07s11.4-7.14 27.91-4.12c18 3.29 28.67 20.59 28.67 20.59s9-2.59 20.44-.92 18.34 6.7 18.34 6.7z"
        />
        <radialGradient
            id="e"
            cx="78.11"
            cy="91.27"
            r="35.93"
            gradientTransform="matrix(.3939 .9191 -2.2871 .9802 256.08 -69.99)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".27" stopColor="#F1F1F0" />
            <stop offset=".65" stopColor="#D9E5E6" />
            <stop offset="1" stopColor="#C0D8DC" />
        </radialGradient>
        <path
            fill="url(#e)"
            d="M124.15 85.01v31.73a7.52 7.52 0 0 1-7.52 7.52H28.6s8.57-10.52 22.5-15.16c14.34-4.78 22.7-4.18 22.7-4.18s7.83-10.97 21.9-16.13c14.14-5.18 28.45-3.78 28.45-3.78z"
        />
    </svg>
);

export const RainIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 128 128"
    >
        <path
            fill="#E2EBEE"
            d="M107.62 46.29s1.72-32.32-23.89-38.72C54.12.17 48.29 28.49 48.29 28.49s-11.55-2.19-18.74 5.62c-6.03 6.55-5.46 12.96-5.46 12.96s-7.96-1.72-14.21 3.75-5.31 10.61-5.31 10.61l18.58 7.18s93.83.47 94.3.16c.47-.31 6.25-9.37 6.25-9.37s-.94-7.81-6.4-10.93c-5.47-3.12-9.68-2.18-9.68-2.18z"
        />
        <path
            fill="#B9CED2"
            d="M14.25 73.45c4.68.16 35.29.78 53.86.62s46.81.14 50.73-1.71c3.07-1.45 4.9-3.85 5.19-7.21.28-3.21-.34-5.75-.34-5.75s-4.37 3.16-12.65 3.28c-5.15.07-15.61-.78-13.58-2.65.57-.53 8.66-6.66 8.27-12.33-.09-1.34-7.34 5.31-14.21 8.12-6.87 2.81-13.39 4.98-22.47 4.4-7.65-.5-10.97-3.61-10.97-3.61s-3.69 4.33-14.78 5.26c-11.09.94-13.48-3.23-13.48-3.23s-5.37 4.06-14.39 3.94c-9-.14-10.77-3.38-10.77-3.38s-.85 5.77 1.03 9.14a10.13 10.13 0 0 0 8.56 5.11z"
        />
        <path
            fill="#4FC4F8"
            d="M69.99 81.57c-1.71-.6-7.81 4.23-10.56 9-2.76 4.79-.96 8.29 1.99 9.73 3.32 1.62 8.1.62 9.46-4.1 1.34-4.67.95-13.98-.89-14.63zm-32.33-2.38c-1.55-.55-6.58 4.12-8.84 6.64-3.03 3.39-5.37 9.71.38 12.27 5.79 2.57 9.55-1.64 9.84-7.46.28-5.42-.1-10.99-1.38-11.45zm12.21 22.46c-1.65-.89-8.58 5.26-10.79 8.93-2.2 3.67-2.06 8.38 2.44 10.31s8.47-.54 9.3-6.97c.58-4.56.64-11.41-.95-12.27zm33.51.53c-1.19-.67-9.43 5.69-11.28 10.32a6.35 6.35 0 0 0 11.72 4.65c1.66-5.04 1.03-14.14-.44-14.97zm20.49-19.81c-1.63-1-8.48 4.64-10.76 8.88-2.88 5.36-.64 9.4 2.5 10.68 3.26 1.32 7.45.05 8.87-4.78 2.05-6.96.97-13.8-.61-14.78z"
        />
        <path
            fill="#AEE6FD"
            d="M96.4 91.09c-1.08.13-2.42 1.67-2.63 4.3s1.45 3.96 3.13 3.29c1.58-.63 1.84-2.88 1.84-4.3s-.67-3.5-2.34-3.29zM63 90.26c-1.14-.32-3.26 1.44-3.63 4.29-.29 2.2.56 3.53 2.27 3.66 2.38.18 3.13-2.75 3.07-4.54-.04-1.02-.22-2.99-1.71-3.41zm-20.55 19.53c-1.06-.08-2.84 1.7-2.84 4.47s1.44 3.97 3.14 3.6c1.7-.38 2.04-3.63 1.93-4.92-.11-1.29-.66-3.03-2.23-3.15zM30.91 88.44c-1.43-.41-3.26 1.4-3.48 3.44-.23 2.04.72 3.52 2.23 3.75 1.51.23 2.8-1.59 2.95-3.71.16-2.12-.37-3.11-1.7-3.48zm45.49 22.53c-1.32-.11-3.21 1.84-3.16 4.79s1.58 3.45 2.59 3.51c1.45.09 2.46-1.62 2.59-4.3.11-2.25-.4-3.87-2.02-4z"
        />
    </svg>
);

export const RefreshIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 1024 1024"
    >
        <path
            fill="#888"
            d="M772 795a384 384 0 0 1-644-283h64a320 320 0 0 0 556 216h-93a32 32 0 1 1 0-64h149a32 32 0 0 1 32 32v149a32 32 0 1 1-64 0v-50zM276 296h93a32 32 0 0 1 0 64H220a32 32 0 0 1-32-32V179a32 32 0 0 1 64 0v50a384 384 0 0 1 644 283h-64a320 320 0 0 0-556-216z"
        />
    </svg>
);

export const SnowIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 128 128"
    >
        <path
            fill="#95C7EC"
            d="m69.83 50.53-.4-18.43s9.61-5.08 11.45-8.43 1.08-8.97-.97-9.18C77.86 14.28 69 20.76 68.25 20c-.76-.76 3.67-6.16 3.46-8.21-.22-2.05-6.81-7.07-6.81-7.07l-7.45 8.47s2.16 6.7 1.84 7.35-10.48-5.62-12.64-5.19c-2.16.43-1.42 4.82-.67 6.88.76 2.05 14.6 8.46 14.6 8.46l-.6 20.12s-2.53-.04-3.18.29c-.65.32-2.2 2.92-2.2 2.92s-14.55-7.88-14.66-9.5.22-16.1-.54-17.61c-.76-1.51-4-3.27-5.62-3.27s-2.7 16.01-3.67 16.01-4.65-9.4-5.73-9.4-9.45 1.4-9.45 1.4l3.19 12.75 9.94 2.05-12.17 13.76s2.98 2.9 5.79 2.25 10.91-8.75 11.77-8.75c.86 0 15.56 8.43 15.56 8.43s-.65 1.51-.22 2.38c.43.86 1.19 1.94 1.19 1.94S35.4 75.32 34.42 75.1s-10.8-7.24-13.61-7.24-4.54 3.67-4.54 3.67l11.67 9.83-9.83 4.86-4.21 8.75s9.51 3.35 10.8 3.02 4.65-8.32 5.29-8.53c.65-.22.89 1.82.89 1.82s3.43 10.72 4.73 10.39 4.54-2.38 4.97-4-.64-14.47-.64-14.47l15.34-8.33s1.22 1.98 2.05 2.58c.65.47 3.88.78 3.88.78l-.43 16.74s-16 6.9-16.54 8.84c-.54 1.94-.42 6.28 1.1 6.82 1.51.54 13.31-4.86 13.85-4.43.54.43-.23 8.42-.23 8.42s6.34 8.96 7.74 8.1 6.31-6.36 6.35-7.38c.09-1.93-4.72-8.58-4.63-8.97.19-.85 9.98 6.2 11.71 5.98 1.73-.22 3.02-2.05 3.02-4.11 0-2.05-13.18-11.77-13.18-11.77l-.21-18.57s2.55-.14 3.42-.57c.86-.43 2.58-4.34 2.58-4.34l15.71 10.53s-.65 17.72.97 18.8c1.62 1.08 4.54 1.73 5.62 1.19s1.19-15.66 1.19-15.66l6.81 6.16s9.78-.87 9.78-2.17-1.96-8.64-2.75-9.28c-1.41-1.14-7.63-.58-8.36-.97-.58-.31 11.38-5.08 11.38-7.02s-3.91-5.01-4.99-5.12c-1.08-.11-15.21 6.2-15.21 6.2l-16.42-9.72s.86-1.51.86-2.27-1.07-2.03-1.07-2.03l16.84-9.2s14.8 5.29 16.2 4.65c1.4-.65 2.59-1.84 2.59-3.02s-12.5-6.93-11.56-7.45c.72-.4 7.67.43 8.75 0s4.52-9.19 4.41-9.62c-.11-.43-11.76-3.34-11.76-3.34l-5.19 6.16s.86-11.67-.43-12.96-4.78-.65-6.18.32c-1.4.97-2.24 18.15-2.24 18.15l-15.84 8.59s-1.48-2.38-2.35-2.82c-.85-.47-2.69-.56-2.69-.56z"
        />
        <path
            fill="#AFE3FF"
            d="M76.44 56.05 95 46.37l-.28-19.97s-2.88.49-4.29 2.37c-1.41 1.88-.94 14.51-.94 14.51l-16.06 8.73 3.01 4.04zM99.48 43.9s6.08-7.56 7.25-7.94c1.96-.64 9.53 2.02 9.53 2.02s.84-2.09.5-2.9c-.34-.81-9.65-4.97-11.88-4.18-1.74.62-5.28 7.34-5.28 7.34l-.12 5.66zm-.52 6.84c-.4-.07-3.64 2.05-3.64 2.05s9.62 5.83 12.44 5.96c3.48.17 5.78-2.37 5.78-2.37s-2.49.07-4.3-.6c-2.95-1.1-10.28-5.04-10.28-5.04zM77.19 70.09l-2.28 4.64s13.71 8.53 13.77 8.94c.07.4-.34 15.18 1.08 16.86 1.41 1.68 4.1 2.55 4.1 2.55s.81-21.77.74-22.11c-.08-.34-17.41-10.88-17.41-10.88zm17.49 4.79s9.66-6.54 12.28-6.54c2.62 0 4.84 1.34 4.84 1.34l-12.78 7.73-4.34-2.53zm5.02 9.83c-.34.94-.51 4.46-.51 4.46s3.14 7.39 5.35 8.19c2.22.81 10.68-2.35 11.36-3.16.67-.81-.32-4.09-.32-4.09s-6.69 2.65-8.69 2.28c-2.56-.47-7.19-7.68-7.19-7.68zM59.03 54.84c-.97.97-5.2 7.18-5.28 8.38-.08 1.21 4.63 9.26 5.76 9.9 1.13.64 10.23 0 10.23 0l4.67-9.59s-4.11-8.78-4.75-8.94-9.98-.4-10.63.25zm4.15-32.78c.64.12-2.37-8.95-2.37-8.95l6.66-6.29s-2.48-3.06-3.76-3.06c-1.29 0-8.3 6.52-8.3 8.06s3.87 8.72 3.87 8.72 2.68 1.29 3.9 1.52zm-17.94-3.13s.01 4.53 1.46 6.14c1.45 1.61 11.77 6.66 11.77 6.66l.26 19.11 4.49-.02V28.58s-8.94-4.27-10.71-5.07c-1.77-.81-5.98-2.89-7.27-4.58zm-5.62 28.74 13.53 8.54 2.18-3.3-15.39-9.02zm-9.65-7.93s2.86 2.81 3.48 2.79c1.2-.04 1.12-18.75 1.12-18.75s-2.31-.87-3.52.26c-1.22 1.12-1.08 15.7-1.08 15.7zm-1.46 4.55c2.87.73 2.33 2.74 1.93 3.38-.4.64-13.53 13.37-13.53 13.37s-2.5-1.37-2.5-2.82c0-1.45 11.39-10.82 10.79-10.96-.47-.1-8.62 1.27-10.39.16-1.14-.71-4.3-12.6-3.7-14.2.48-1.29 4.59-1.67 4.59-1.67s1.45 10.63 2.58 11.2c1.12.57 7.94.96 10.23 1.54zM49.7 65.97l-16.04 8.8 4.03 3.27 14.01-9.02zM31.41 80.78c-.12 1.37-5.76 4.13-6.24 4.54-.48.4-5.76-.83-6.09-.35-.32.48-3.35 9.8-3.92 10.35-.08.08-3.29-.92-3.53-1.45-.58-1.27 3.02-11.32 4.63-12.77 1.61-1.45 8.7.4 8.94-.08.24-.48-9.26-5.64-9.99-7.25-.72-1.61 2.34-4.19 2.34-4.19s14.02 9.34 13.86 11.2zm2.08 5.32c-.53-.37-3.32 3.34-3.32 3.34s.98 11.99 1.89 12.76c.92.78 3.57-.54 3.57-.54s-1.34-15-2.14-15.56zm25.71-8.17s.15 14.93-.17 15.49c-.32.56-12.47 6.33-14.18 8.54-1.16 1.5-.86 5.45-.86 5.45s18.66-10.52 19.06-10.84c.4-.32.09-18.59.09-18.59l-3.94-.05zm23.93 30.64s-12.83-7.95-12.98-9.02c-.15-1.02-.23-5.44-.23-5.44s11.27 7.93 12.4 9.78c1.13 1.85.81 4.68.81 4.68zm-22.73 4.99c.2 2.09 7.62 8.05 7.62 8.05s-2.35 2.54-3.56 2.62c-1.21.08-9.14-7.53-9.3-8.81-.16-1.29 4.03-9.42 4.03-9.42s1.88-.9 3.3-1.2c.9-.2-2.28 6.73-2.09 8.76z"
        />
        <path
            fill="#FEFEFE"
            d="M71 62.49s-1.19 2.37-1.78 3.71-1.33 3.63-1.33 3.63-5.56.43-7.04.37c-1.93-.07-3.04 3.41-.22 3.48 2.82.07 9.56.22 10.15-.22.59-.44 4.96-8.45 4.96-10.23s-3.85-6.74-5.26-8.15c-1.64-1.64-4.52 0-2.89 2.67S71 62.49 71 62.49zm22.43-32.86c-2.26-.08-2.09 2.98-2.01 6.52s.32 5.88 2.17 5.88c2.26 0 1.85-4.91 1.85-7.17 0-2.25.33-5.15-2.01-5.23zM63.79 7.56c1.31 1.31-.48 3.54-1.21 4.19-.72.64-2.74 1.93-4.11.64s.24-3.14 1.53-4.11c1.29-.97 2.82-1.69 3.79-.72zm-.49 20.3c-2.09-.24-2.01 4.91-1.93 11.2.1 8.06 0 11.84 1.69 11.76 1.93-.09 1.37-4.11 1.37-12.49 0-4.6.48-10.29-1.13-10.47zm-48.33 5.23c-2.73.85-1.53 4.19-.81 6.61.46 1.54 1.86 5.93 4.43 5.16 2.57-.77 1.05-4.43.48-6.77-.55-2.34-1.76-5.72-4.1-5zM92.3 89.56c-1.61 0-1.77 3.06-1.77 5.8s0 4.75 1.85 4.75 1.53-4.03 1.53-5.48c0-1.45.25-5.07-1.61-5.07zM63.14 77.88c-1.37.06-1.53 3.14-1.53 9.18s-.33 9.61 1.69 9.51c1.61-.08 1.29-6.12 1.29-10.23s.49-8.54-1.45-8.46zm-25.93.06c.81.94 4.95-1.69 7.93-3.33 3.58-1.97 7.55-3.86 6.71-5.53-.84-1.67-5.03 1.29-7.93 2.8-2.9 1.52-8.08 4.47-6.71 6.06zm-12.5 7.83c-.87.65-3.3.24-4.35 1.05-1.05.81-1.27 3.55-2.5 4.03-1.85.72-3.3-.56-2.34-3.06.97-2.5 1.29-4.19 2.17-4.83.89-.64 4.11-.48 5.4-.48 2.26-.01 2.91 2.32 1.62 3.29z"
        />
    </svg>
);

export const SunBehindCloudIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 128 128"
    >
        <path
            fill="#FCC11A"
            d="M29.53 45.25c-7.14 9.17-7.02 25.48 2.11 33.55 10.36 9.17 24.93 9.08 34.1.64 10.99-10.11 10.36-26.95.64-36.48-9.77-9.59-27.23-10.09-36.85 2.29z"
        />
        <path
            fill="#FEE269"
            d="M40.99 42.1c-2.82-1.25-5.91 2.15-7.26 4.48s-2.6 6.9.27 8.06 4.93-.81 6.99-4.21c2.06-3.4 3.22-6.89 0-8.33z"
        />
        <path
            fill="#FFA722"
            d="M48.34 29.31c-.68 1.28-.45 2.26.9 2.59 1.36.32 9.82 1.7 10.53 1.74 1.03.06 1.42-.71 1.29-1.62-.13-.9-2.2-13.57-2.39-14.74-.19-1.16-1.42-2.33-2.59-.78a313.9 313.9 0 0 0-7.74 12.81zm21.91 8.79c-1.33.41-1.29 1.23-.58 2.26.71 1.03 5.62 8.53 6.08 9.05s1.23.65 1.87-.13 8.72-12.09 9.31-12.8c.97-1.16.39-2.39-1.1-2-1.14.3-14.74 3.37-15.58 3.62zM19.84 72.49c.9-1.49 2.07-1.1 2.91.32.58.97 5.43 7.5 5.88 8.21.45.71.65 2.07-.78 2.39-1.42.32-12.99 3.36-14.8 3.68s-2.84-1.1-1.68-2.65c.68-.9 7.95-11.11 8.47-11.95zm-2.46-11.25c1.65.74 2.43.47 2.78-.71.45-1.55 1.81-8.66 1.87-10.28.04-1.05-.39-2.07-2-1.81-1.62.26-13.25 1.87-14.74 2.39-1.73.6-1.6 2.5-.45 3.1 1.36.72 11.38 6.79 12.54 7.31zm20.1-27.14c.93-.74.65-1.81-.19-2.39-.84-.58-11.22-8.09-12.54-9.11-1.16-.9-2.59-.58-2.2 1.49.28 1.48 3.59 14.48 3.81 15.38.26 1.03 1.03 1.55 1.94.9.91-.65 8.21-5.5 9.18-6.27z"
        />
        <path
            fill="#E2EBEE"
            d="M109.13 81.18s1.45-28.45-21.58-34-29.74 16.79-29.74 16.79-7.68-1.79-14.8 4.13c-5.59 4.65-6.38 11.63-6.38 11.63s-7.35-1.12-13.47 4.82c-4.43 4.3-4 9.82-4 9.82l8.92 7.84 90.65-2.45 4.77-5.12s.76-5.68-4.54-9.95c-5.3-4.28-9.83-3.51-9.83-3.51z"
        />
        <path
            fill="#B9CED3"
            d="M40.64 92.23s3.61 4.08 15.06 3.81 14.46-3.27 14.46-3.27 5.02 5.27 19.53 4.15 18.68-4.18 18.68-4.18 3.54 2.53 8.02 2.6c4.47.07 7.11-.71 7.11-.71s-.47 3.56-2.03 5.84c-1.56 2.28-4.16 4.02-8.27 3.99-4.12-.03-16.64.08-29.35.06-12.71-.02-49.03.19-54.4-.04a10.88 10.88 0 0 1-8.43-4.62c-2.19-3.26-1.83-6.7-1.83-6.7s4.12 3.23 9.68 2.99c7.6-.32 11.77-3.92 11.77-3.92z"
        />
    </svg>
);

export const SunBehindLargeCloudIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 128 128"
    >
        <path
            fill="#FCC11A"
            d="M29.12 39.22c-4.79 6.16-4.71 17.1 1.41 22.52 6.95 6.15 16.73 6.09 22.88.43 7.38-6.79 6.95-18.09.43-24.48-6.55-6.44-18.26-6.78-24.72 1.53z"
        />
        <path
            fill="#FEE269"
            d="M36.81 37.11c-1.89-.84-3.97 1.44-4.87 3.01-.9 1.56-1.74 4.63.18 5.41s3.31-.54 4.69-2.83c1.39-2.29 2.17-4.63 0-5.59z"
        />
        <path
            fill="#FFA722"
            d="M41.74 28.53c-.46.86-.3 1.52.61 1.73.91.22 6.59 1.14 7.07 1.17.69.04.95-.48.87-1.08s-1.47-9.11-1.6-9.89c-.13-.78-.95-1.56-1.73-.52s-4.87 7.94-5.22 8.59zm14.71 5.89c-.89.28-.87.82-.39 1.52.48.69 3.77 5.72 4.08 6.07.3.35.82.43 1.26-.09.43-.52 5.85-8.11 6.25-8.59.65-.78.26-1.6-.74-1.34-.77.2-9.9 2.26-10.46 2.43zM22.62 57.5c.61-1 1.39-.74 1.95.22.39.65 3.64 5.03 3.95 5.51.3.48.43 1.39-.52 1.6-.95.22-8.72 2.26-9.93 2.47-1.21.22-1.91-.74-1.13-1.78.45-.61 5.33-7.46 5.68-8.02zm-1.65-7.55c1.11.49 1.63.32 1.86-.48.3-1.04 1.21-5.81 1.26-6.9.03-.71-.26-1.39-1.34-1.21-1.08.17-8.89 1.26-9.89 1.6-1.16.4-1.08 1.68-.3 2.08.91.49 7.63 4.56 8.41 4.91zm13.49-18.21c.62-.5.43-1.21-.13-1.6-.56-.39-7.53-5.43-8.41-6.12-.78-.61-1.73-.39-1.47 1 .19 1 2.41 9.72 2.56 10.32.17.69.69 1.04 1.3.61.6-.44 5.5-3.69 6.15-4.21z"
        />
        <path
            fill="#E2EBEE"
            d="M107.33 76.86c-.14-.46 4.52-33.89-25.85-38.83-27.2-4.42-33.1 20-33.1 20s-10.33-1.73-17.76 5.61c-6.13 6.05-6.93 12.86-6.93 12.86S16.1 75 9.46 80.07C2.78 85.17 4.41 90.5 4.41 90.5l15.36 10.62 90.55-2.72 12.86-3.44s2.21-7.81-5.25-13.8c-6.02-4.83-10.6-4.3-10.6-4.3z"
        />
        <path
            fill="#B9CED3"
            d="M30.29 90.24s-5.41 3.54-14.13 2.6c-9.99-1.08-11.82-4.86-11.82-4.86s-1.09 7.4 4.93 12.39c5.44 4.51 12.29 3.35 21.83 3.41s73.63-.03 79.69.03c4.96.05 8.97-1.5 11.09-5.63 2.01-3.9 1.55-6.02 1.55-6.02s-3.61 2.24-11.47 1.32c-6.79-.79-10.11-3.53-10.11-3.53s-8.63 4.42-23.04 4.24c-15.1-.19-20.23-5.73-20.23-5.73s-4.9 4.64-15.67 4.37-12.62-2.59-12.62-2.59z"
        />
    </svg>
);

export const SunBehindRainIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 128 128"
    >
        <path
            fill="#FCC11A"
            d="M38.29 29.14c-6.01 7.73-5.91 21.47 1.78 28.27 8.73 7.72 21.01 7.65 28.74.54 9.26-8.52 8.73-22.71.54-30.74-8.24-8.08-22.95-8.5-31.06 1.93z"
        />
        <path
            fill="#FEE269"
            d="M47.95 26.49c-2.38-1.06-4.98 1.81-6.12 3.78-1.13 1.96-2.19 5.81.23 6.8 2.42.98 4.15-.68 5.89-3.55 1.74-2.88 2.72-5.82 0-7.03z"
        />
        <path
            fill="#FFA722"
            d="M54.14 15.71c-.58 1.08-.38 1.91.76 2.18 1.14.27 8.28 1.43 8.88 1.47.87.05 1.2-.6 1.09-1.36-.11-.76-1.85-11.44-2.02-12.42-.16-.98-1.2-1.96-2.18-.65s-6.09 9.96-6.53 10.78zm18.46 7.41c-1.12.35-1.09 1.03-.49 1.91.6.87 4.74 7.19 5.12 7.62.38.44 1.03.54 1.58-.11s7.35-10.19 7.84-10.78c.82-.98.33-2.02-.93-1.69-.94.25-12.41 2.83-13.12 3.05zM30.12 52.09c.76-1.25 1.74-.93 2.45.27.48.82 4.57 6.32 4.96 6.92.38.6.54 1.74-.65 2.02-1.2.27-10.95 2.83-12.47 3.1s-2.4-.93-1.42-2.23c.57-.77 6.7-9.37 7.13-10.08zm-2.06-9.48c1.39.62 2.05.4 2.34-.6.38-1.31 1.52-7.3 1.58-8.66.04-.89-.33-1.74-1.69-1.52s-11.16 1.58-12.42 2.02c-1.45.51-1.35 2.11-.38 2.61 1.14.6 9.59 5.72 10.57 6.15zm16.93-22.87c.78-.63.54-1.52-.16-2.02-.71-.49-9.46-6.82-10.57-7.68-.98-.76-2.18-.49-1.85 1.25.23 1.25 3.02 12.21 3.21 12.96.22.87.87 1.31 1.63.76.77-.53 6.93-4.62 7.74-5.27z"
        />
        <path
            fill="#E2EBEE"
            d="M99.22 65.16s3.54-23.47-17.6-29.03C58.67 30.09 53.29 51.4 53.29 51.4s-6.68-1.82-12.85 3.14c-4.83 3.88-5.66 10.72-5.66 10.72s-9.41-.32-13.45 6.17c-3.84 6.17 0 10.22 0 10.22l55.54-2.23 34.19.2s2.47-6.42-2.28-10.87c-4.76-4.44-9.56-3.59-9.56-3.59z"
        />
        <path
            fill="#B9CED3"
            d="M61.29 67.49s4.25 4.25 15.38 3.54 16.99-4.65 18.31-5.26c1.32-.61 2.83-2.02 3.34-1.01.51 1.01-.61 3.84-2.12 5.87-1.52 2.02-2.37 3.25-2.63 4.15-.2.71 3.14 1.72 9.41 2.02 5.36.26 8.74-.82 8.74-.82s.15 3.37-1.16 6c-1.22 2.43-2.49 3.22-4.51 3.63-1.04.21-20.67.2-37.56.6-16.89.4-38.95 1.11-42.69-.1s-4.66-3.58-5.14-4.5c-.84-1.58-1.02-4.05-1.02-4.05s4.14 2.08 10.01 1.27 9-3.84 9.81-4.15c.81-.3 4.65 1.62 10.72.1 8.48-2.13 11.11-7.29 11.11-7.29z"
        />
        <path
            fill="#4FC2F7"
            d="M47.26 90.91c-1.32-.48-7.05 3.63-9.11 9.11-3.04 8.09 7.79 10.79 10.07 3 .87-2.96.86-11.45-.96-12.11zm42.81 5.9c-1.17-.52-5.82 3.02-7.93 5.99-2.02 2.84-3.82 7.64 1.14 10.1 5.41 2.67 7.87-3.14 8.1-7.36.21-3.82-.28-8.27-1.31-8.73zm-23.55 9.59c-1.47-.35-7.11 4.23-9.13 8.5-4.05 8.56 8.39 11.58 9.93 3.37.98-5.21.4-11.59-.8-11.87z"
        />
        <path
            fill="#AFE6F8"
            d="M61.24 113.05c-1.17-.47-3.45 2.4-3.2 4.95.26 2.55 2.36 2.78 3.36 1.37 1.34-1.87 1-5.86-.16-6.32zM41.68 97.56c-1.11-.52-3.01 2.52-2.99 4.09.05 3.2 2.41 3.41 3.51 1.83 1.1-1.57 1.05-5.18-.52-5.92zm43.15 6.21c-1.32-.63-3.59 2.28-3.42 4.39.3 3.64 3.19 3.42 4.16 1.43s.45-5.25-.74-5.82z"
        />
    </svg>
);

export const SunIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 128 128"
    >
        <path
            fill="#FCC11A"
            d="M37.41 41.95c-9.71 12.48-9.54 34.65 2.87 45.64 14.09 12.47 33.92 12.34 46.39.87 14.95-13.76 14.09-36.66.87-49.63-13.29-13.04-37.04-13.72-50.13 3.12z"
        />
        <path
            fill="#FEE269"
            d="M53 37.67c-3.84-1.7-8.04 2.93-9.87 6.09-1.83 3.17-3.53 9.38.37 10.97 3.9 1.58 6.7-1.1 9.51-5.73 2.79-4.63 4.38-9.38-.01-11.33z"
        />
        <path
            fill="#FFA722"
            d="M63 20.27c-.93 1.74-.62 3.08 1.23 3.52 1.85.44 13.36 2.31 14.33 2.37 1.41.09 1.93-.97 1.76-2.2-.18-1.23-2.99-18.46-3.25-20.04S75.14.76 73.55 2.87 63.7 18.96 63 20.27zm29.8 11.96c-1.81.56-1.76 1.67-.79 3.08.97 1.41 7.65 11.6 8.26 12.31.62.7 1.67.88 2.55-.18.88-1.05 11.86-16.45 12.66-17.41 1.32-1.58.53-3.25-1.49-2.73-1.54.41-20.05 4.58-21.19 4.93zm13.8 29.63c-1.3-.74-2.99-.53-3.43 1.14-.44 1.67-2.37 13.8-2.55 14.86s.62 2.11 1.93 1.85 19.45-2.95 20.66-3.25c2.11-.53 2.81-2.64.62-4.22-1.42-1.03-16-9.68-17.23-10.38zM92.09 90.6c1.4-.75 2.64-.18 2.99 1.41.35 1.58 4.22 17.76 4.84 20.75.31 1.5-1.41 2.73-2.81 1.85a650.36 650.36 0 0 1-17.67-12.4c-1.41-1.23-.43-2.51.26-3.16 1.4-1.33 11.07-7.74 12.39-8.45zm-42.55 8.88c-1.77-.17-2.29 1.41-2.02 2.81.26 1.41 2.9 19.24 3.08 20.57.26 1.93 2.29 2.73 3.6.79s10.35-16.4 11.08-17.76c1.32-2.46.35-2.99-.97-3.6-1.31-.61-12.92-2.63-14.77-2.81zM24.23 79c1.23-2.02 2.81-1.49 3.96.44.78 1.32 7.38 10.2 8 11.16.62.97.88 2.81-1.05 3.25-1.95.45-17.68 4.58-20.14 5.02-2.46.44-3.87-1.49-2.29-3.6.92-1.24 10.82-15.12 11.52-16.27zm-3.34-15.3c2.25 1 3.31.64 3.78-.97.62-2.11 2.46-11.78 2.55-13.98.06-1.43-.53-2.81-2.73-2.46S6.47 48.85 4.45 49.55c-2.35.82-2.18 3.4-.62 4.22 1.85.97 15.47 9.23 17.06 9.93zm27.34-36.92c1.27-1.01.88-2.46-.26-3.25-1.14-.79-15.26-11-17.05-12.4-1.58-1.23-3.52-.79-2.99 2.02.38 2.02 4.88 19.7 5.19 20.92.35 1.41 1.41 2.11 2.64 1.23 1.21-.87 11.15-7.46 12.47-8.52z"
        />
    </svg>
);
